import React from 'react'

import './button.css'

export default function ExternalLinkButton({ children, className = '', button='primary', to, disabled, outline = false , target="_blank", onClick}) {
  return (
      <a href={to} target={target} className={`btn mb-1 ${className} btn-${outline?'outline-':''}${button}`} disabled={disabled} onClick={() => onClick ? onClick() : null}>{children}</a>
  )
}
